import styled from 'styled-components';
import { backgroundImage, experienceDetails } from '../../../contants';
import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';

const ExperienceTile = () => {
  return (
    <Wrapper>
      <ProjectBackgroundImage alt='error' src={backgroundImage.project3} />
      <ContentWrapper>
        <Header>Experience</Header>
        <Content>
          {experienceDetails.map((experience, index) => (
            <Box key={index} as={motion.div} whileHover={{ scale: 1.1 }}>
              <NavLink to={`/experience/${experience.companyName}`}>
                <Logo src={experience.logo} />
              </NavLink>
            </Box>
          ))}
        </Content>
      </ContentWrapper>
    </Wrapper>
  );
};

const Logo = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  border-radius: 30px;
`;
const ContentWrapper = styled.div`
  position: absolute;
  padding: 40px 44px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  @media (max-width: 500px) {
    padding: 20px 22px;
  }
`;
const Header = styled.div`
  margin-bottom: 8px;
  line-height: 32px;
  font-size: 24px;
  font-weight: 800;
  color: ${({ theme }) => theme.background};
  filter: drop-shadow(0.1rem 0.1rem 0.2rem hsla(0, 24%, 30%, 0.3));
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  height: 90%;
  width: 100%;
  padding: 40px 0;
  gap: 8px;
  @media (max-width: 500px) {
    gap: 8px;
    height: fit-content;
    padding: 10px 0 20px 0;
  }
`;
const BackgroundImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const ProjectBackgroundImage = styled(BackgroundImage)`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 30px;
`;

const Box = styled.div`
  background-color: hsl(0, 24%, 96%);
  flex: 1;
  border-radius: 24px;
  overflow: hidden;
  @media (max-width: 500px) {
    border-radius: 18px;
  }
`;

export default ExperienceTile;
